<mat-form-field class="mat-input-custom" appearance="outline">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    aria-label="state"
    #autoCompleteInput
    [matAutocomplete]="stateAuto"
    [formControlName]="formControlNameData"
    [id]="idAutomation"
    [readonly]="true"
    appAlphabetOnly
  />
  <mat-autocomplete #stateAuto="matAutocomplete">
    <mat-option
      *ngFor="let state of filteredStateList | async"
      [value]="state.display_name"
    >
      <span>{{ state.display_name }}</span>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
